import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialFeatured() {
  return <FadeIn delay={0.2} data-id="element-313">
      <section className="py-12 px-4 max-w-4xl mx-auto pt-[0px] pb-[0px]" data-id="element-314">
        <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden pt-[0px] pb-[0px]" data-id="element-315">
          <Quote className="absolute top-4 left-4 md:top-8 md:left-8 text-gray-800 w-16 h-16 md:w-24 md:h-24 -z-10 rotate-180 opacity-50" data-id="element-316" />

          <p className="text-xl md:text-3xl font-medium text-gray-200 leading-relaxed mb-6 italic relative z-10" data-id="element-317">
            "Organicé toda mi agenda y mis finanzas en una tarde. Los scripts me
            ahorran 30 minutos de WhatsApp por día y las clientas dejan de
            cancelar a último momento."
          </p>

          <div className="flex items-center justify-center gap-3" data-id="element-318">
            <div className="w-10 h-10 bg-pink-900 rounded-full flex items-center justify-center text-pink-400 font-bold text-lg" data-id="element-319">
              D
            </div>
            <div className="text-left" data-id="element-320">
              <p className="font-bold text-white" data-id="element-321">Daniela R.</p>
              <p className="text-sm text-gray-400" data-id="element-322">
                Manicurista independiente · Rosario
              </p>
            </div>
          </div>
        </div>
      </section>
    </FadeIn>;
}